import React from 'react';
import { Tabs } from 'antd';
import MiniDrawer from "../../Component/newNavBarCM/newNavBar";
import Styles from './CmIngestedStyles.module.css';
import JobsTable from '../../Component/CmIngestedKnowledge/JobsTable';
import CsvTables from '../../Component/CmIngestedKnowledge/CsvTables';
import CrawlDocsTable from '../../Component/CmIngestedKnowledge/CrawlDocsTable';
import DrawerComponent from '../../Component/Drawer/Drawer';
import Layout from '../../NewComponent/LayoutCM/Layout';

export default function CmIngestedPage() {
  // const renderTitle = (title) => {
  //   return (
  //     <div style={{ textAlign: "center" }}>
  //       <span style={{ fontWeight: "300", fontSize: "18px" }}>{title}</span>
  //     </div>
  //   );
  // };
  const renderTitle = (text) => {
    return <span style={{ fontSize: "20px", }}>{text}</span>;
  };
  const items = [
    {
      key: '1',
      label: renderTitle('Jobs List'),
      children: <JobsTable/>,
    },
    {
      key: '2',
      label: renderTitle('Scraped Url List'),
      children: <CrawlDocsTable/>,
    },
    {
      key: '3',
      label: renderTitle('XLS List'),
      children: <CsvTables/>,
    },
  ];
  return (
   <>
   <Layout>
   <div className={Styles.container}>
    <div style={{width:'50%'}}>
    <DrawerComponent/>
    </div>
    <Tabs 
      tabBarStyle={{
        itemHoverColor: "linear-gradient(90deg, #00D1FF, #0075FF)", 
        // itemSelectedColor: "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
        itemActiveColor:"linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
      }}
    style={{borderColor:'green'}} defaultActiveKey="1" items={items} onChange={()=>console.log("hello")} />
   </div>
   </Layout>
   </>
  )
}
